export default {
  computed: {
    isBackend () {
      return this.$route.path.includes('/backend-tech-support')
    },
  },
  created () {
    this.singleActions = [
      {
        label: this.$t('scope.pay'),
        action: obj => {
          this.$router.push({ path: '/account/checkout', query: { bill_id: obj.bill_id } })
        },
        meta: (obj) => {
          return {
            validate: obj.status === 'pending',
          }
        },
        hidden: (obj) => this.isBackend,
      },
      {
        label: this.$t('dialog.cancel'),
        action: obj => {
          this.createDialog('SaasTechSupportCancelDialog', {
            data: [obj],
            columns: this.columns,
            onManager: this.onManager,
          })
        },
        meta: (obj) => {
          return {
            validate: obj.status === 'pending' || obj.status === 'escalating' || obj.status === 'request_refund',
          }
        },
        // hidden: (obj) => obj.status !== 'pending',
      },
      {
        label: this.$t('common.more'),
        actions: (obj) => {
          return [
            {
              label: this.$t('scope.view_join_group_qrcode'),
              action: (obj) => {
                this.createDialog('WecomExtGroupsQrcodeDialog', {
                  title: this.$t('scope.join_group_qrcode'),
                  onManager: this.onManager,
                  service_id: obj.id,
                })
              },
              meta: (obj) => {
                return {
                  validate: obj.status === 'active' || obj.status === 'escalating' || obj.status === 'completed' || obj.status === 'request_refund',
                }
              },
            },
            {
              label: this.$t('scope.upgrade'),
              action: obj => {
                this.createDialog('SaasTechSupportUpgradeDialog', {
                  data: [obj],
                  columns: this.columns,
                  onManager: this.onManager,
                })
              },
              meta: (obj) => {
                return {
                  validate: obj.status === 'active' && obj.type === 'consulting',
                }
              },
              hidden: (obj) => this.isBackend,
            },
            {
              label: this.$t('scope.apply_refund'),
              action: obj => {
                this.createDialog('SaasTechSupportRefundDialog', {
                  data: [obj],
                  columns: this.columns,
                  onManager: this.onManager,
                })
              },
              meta: (obj) => {
                return {
                  validate: obj.status === 'active',
                }
              },
              hidden: (obj) => this.isBackend,
            },
            {
              label: this.$t('scope.service.complete'),
              action: obj => {
                this.createDialog('SaasTechSupportCompleteDialog', {
                  data: [obj],
                  columns: this.columns,
                  onManager: this.onManager,
                })
              },
              meta: (obj) => {
                return {
                  validate: obj.status === 'active',
                }
              },
              hidden: (obj) => this.isBackend,
            },
            {
              label: this.$t('scope.refund'),
              action: obj => {
                this.createDialog('SaasTechSupportRefundDialog', {
                  data: [obj],
                  columns: this.columns,
                  onManager: this.onManager,
                  type: 'refund',
                })
              },
              meta: (obj) => {
                return {
                  validate: obj.status === 'request_refund',
                }
              },
              hidden: (obj) => !this.isBackend,
            },
          ]
        },
      },
    ]
  },
}
